// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#get-rep-account{
    max-height: 575px;
    min-height: 575px; 
    overflow-y: scroll;width: 100%;float: left;
}
#get-rep-account .table{
    table-layout: fixed;
}
#get-rep-account .table th:first-child{
    width: 130px;
    max-width: 130px;
}
#get-rep-account .table th:nth-child(2){
    width: 130px;
    max-width: 130px;
}
#get-rep-account .table th:nth-child(3){
    width: 220px;
    max-width: 220px;
}
#get-rep-account .table th:nth-child(4){
    width: 100px;
   max-width: 100px;
}
#get-rep-account .table th:nth-child(5){
    width: 100px;
    max-width: 100px;
}
.hiddendiv{padding:0px;}

.hiddendiv tr td,.hiddendiv tr th,.hiddendiv tr {background:#ECECEC}
.hiddendiv th{font-weight: normal;    vertical-align: top;}


.report-plan-arrow{
    border-radius: 50%;
    height: 30px;
    width: 30px;
    text-align: center;
    padding: 6px 9px;
}

.report-plan-arrow{
    border-color: #00a6c6;
    color: #00a6c6;
}
.accordion-toggle{text-align: right;}
.nav.navbar-nav.admin{float: left;  width: 100%;}
.admin li>a{padding: 0}
.admin>li>a>img{    margin-right: 0;    margin-left: -12px;}
#advance-search .form-group {
    margin-bottom: 21px;
}
@media screen and (max-width: 767px){

    .table-responsive>.table>tbody>tr>td{white-space: inherit;}
   .no-padding {    padding-right: 15px;
        padding-left: 15px;}
}
.navbar-nav>li>a{
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    font-size: 13px;
    margin-left: -7px;

}
.nav>li>a>img {
    max-width: none;
    width: 32px;
    margin-right: 0px;
    margin-bottom: 3px;

}

pre{
    border: none;
    background: none;
    white-space:pre-wrap;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    word-break: keep-all;
}`, "",{"version":3,"sources":["webpack://./src/app/search-customer/search-customer.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB,CAAC,WAAW,CAAC,WAAW;AAC9C;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;GACb,gBAAgB;AACnB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA,WAAW,WAAW,CAAC;;AAEvB,iDAAiD,kBAAkB;AACnE,cAAc,mBAAmB,KAAK,mBAAmB,CAAC;;;AAG1D;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA,kBAAkB,iBAAiB,CAAC;AACpC,sBAAsB,WAAW,GAAG,WAAW,CAAC;AAChD,YAAY,UAAU;AACtB,oBAAoB,eAAe,KAAK,kBAAkB,CAAC;AAC3D;IACI,mBAAmB;AACvB;AACA;;IAEI,qCAAqC,oBAAoB,CAAC;GAC3D,iBAAiB,mBAAmB;QAC/B,kBAAkB,CAAC;AAC3B;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;;AAErB;AACA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,oCAAoC;IACpC,eAAe;IACf,oBAAoB;AACxB","sourcesContent":["#get-rep-account{\r\n    max-height: 575px;\r\n    min-height: 575px; \r\n    overflow-y: scroll;width: 100%;float: left;\r\n}\r\n#get-rep-account .table{\r\n    table-layout: fixed;\r\n}\r\n#get-rep-account .table th:first-child{\r\n    width: 130px;\r\n    max-width: 130px;\r\n}\r\n#get-rep-account .table th:nth-child(2){\r\n    width: 130px;\r\n    max-width: 130px;\r\n}\r\n#get-rep-account .table th:nth-child(3){\r\n    width: 220px;\r\n    max-width: 220px;\r\n}\r\n#get-rep-account .table th:nth-child(4){\r\n    width: 100px;\r\n   max-width: 100px;\r\n}\r\n#get-rep-account .table th:nth-child(5){\r\n    width: 100px;\r\n    max-width: 100px;\r\n}\r\n.hiddendiv{padding:0px;}\r\n\r\n.hiddendiv tr td,.hiddendiv tr th,.hiddendiv tr {background:#ECECEC}\r\n.hiddendiv th{font-weight: normal;    vertical-align: top;}\r\n\r\n\r\n.report-plan-arrow{\r\n    border-radius: 50%;\r\n    height: 30px;\r\n    width: 30px;\r\n    text-align: center;\r\n    padding: 6px 9px;\r\n}\r\n\r\n.report-plan-arrow{\r\n    border-color: #00a6c6;\r\n    color: #00a6c6;\r\n}\r\n.accordion-toggle{text-align: right;}\r\n.nav.navbar-nav.admin{float: left;  width: 100%;}\r\n.admin li>a{padding: 0}\r\n.admin>li>a>img{    margin-right: 0;    margin-left: -12px;}\r\n#advance-search .form-group {\r\n    margin-bottom: 21px;\r\n}\r\n@media screen and (max-width: 767px){\r\n\r\n    .table-responsive>.table>tbody>tr>td{white-space: inherit;}\r\n   .no-padding {    padding-right: 15px;\r\n        padding-left: 15px;}\r\n}\r\n.navbar-nav>li>a{\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n    padding-left: 0px;\r\n    font-size: 13px;\r\n    margin-left: -7px;\r\n\r\n}\r\n.nav>li>a>img {\r\n    max-width: none;\r\n    width: 32px;\r\n    margin-right: 0px;\r\n    margin-bottom: 3px;\r\n\r\n}\r\n\r\npre{\r\n    border: none;\r\n    background: none;\r\n    white-space:pre-wrap;\r\n    font-family: 'Open Sans', sans-serif;\r\n    font-size: 14px;\r\n    word-break: keep-all;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
